<div>
    <input-label [label]="translations.country"></input-label>
    <p-dropdown [options]="options" [formControl]="control" styleClass="w-100"></p-dropdown>
</div>
